/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
let baseUrl
let routerMode = 'hash'
let baseImgPath

if (process.env.NODE_ENV === 'development') {
  baseUrl = 'http://localhost:8081/api'
  // baseUrl = '/api'

  // baseImgPath = '//elm.cangdu.org/img/'
} else {
  baseUrl = 'https://admin.togocloud.net/api'
  // baseImgPath = '//elm.cangdu.org/img/'
}

module.exports = {
  baseUrl,
  routerMode,
  baseImgPath
}



// WEBPACK FOOTER //
// ./src/config/env.js